module.exports = "/_next/static/images/img__form2_right_top_desktop-3ccd30a4aa28a1aedad212db4d5edc00.png";